module.exports = __webpack_public_path__ + "static/media/left_arrow_disable.e4aaf82b.svg";